import fulfill from '../../fulfill';
import { SideEffectFunction } from '../../sideEffects';
import { CORE_API_HOSTNAME } from '../../env';
import { ActionTypes, FetchAccountResponse, GetAccount, FetchClientsResponse } from './actions';
import { Account, Client, Grant } from '../../types/management-auth';

const fetchAccount: SideEffectFunction<GetAccount, FetchAccountResponse> = async action => {
    const result: FetchAccountResponse = await fulfill.get({
        accountId: action.payload.accountId,
        url: `${CORE_API_HOSTNAME}/v1/accounts/${action.payload.accountId}/management/settings`,
        handlers: {
            200: (account: Account) => ({
                type: ActionTypes.FetchAccountResponse,
                payload: {
                    account,
                },
                meta: {
                    cause: action,
                },
            }),
        },
    });
    return result;
};


const fetchClients: SideEffectFunction<GetAccount, FetchClientsResponse> = async action => {
    const accountId = action.payload.accountId;
    const clients: Client[] = await fulfill.get({
        accountId: accountId,
        url: `${CORE_API_HOSTNAME}/v1/accounts/${accountId}/auth/clients`,
        handlers: {
            200: (clients: Client[]) => clients,
            403: () => [],
        },
    });
    let grants: Grant[] = [];
    if (clients.length) {
        const clientIds = clients.map(client => client.client_id).join(',');
        grants = await fulfill.get({
            accountId: accountId,
            url: `${CORE_API_HOSTNAME}/v1/accounts/${accountId}/auth/client-grants?client_id=${clientIds}`,
            handlers: {
                200: (grants: Grant[]) => grants,
                403: () => [],
            },
        });
    }

    const grantsByClientId = grants.reduce((acc: { [clientId: string]: Grant[] }, grant) => {
        if (grant.client_id in acc) {
            return {
                ...acc,
                [grant.client_id]: [...acc[grant.client_id], grant],
            };
        }
        return {
            ...acc,
            [grant.client_id]: [grant],
        };
    }, {});

    return {
        type: ActionTypes.FetchClientsResponse,
        payload: {
            clients: clients,
            grants: grantsByClientId,
        },
        meta: {
            cause: action,
        },
    };
};

const effects = {
    [ActionTypes.GetAccount]: [fetchAccount, fetchClients],
};

export default effects;
